import { useId, useState } from 'react';
import { HelpCircle } from 'lucide-react';

interface TooltipProps {
  content: string;
  children?: React.ReactNode;
}

export default function Tooltip({ content, children }: TooltipProps) {
  const id = useId();
  const tooltipId = `tooltip-${id}`;
  const [isVisible, setIsVisible] = useState(false);

  return (
    <span
      className="relative inline-flex items-center"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      <span
        tabIndex={0}
        aria-describedby={tooltipId}
        className="inline-flex items-center cursor-help"
        onFocus={() => setIsVisible(true)}
        onBlur={() => setIsVisible(false)}
        onKeyDown={(e) => {
          if (e.key === 'Escape') setIsVisible(false);
        }}
      >
        {children ?? <HelpCircle className="w-4 h-4 text-ink-muted" aria-hidden="true" />}
      </span>
      <span
        id={tooltipId}
        role="tooltip"
        className={`absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-2 bg-ink text-surface text-xs rounded-lg shadow-lg transition-all duration-150 whitespace-normal w-64 text-center z-50 pointer-events-none ${
          isVisible ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
      >
        {content}
        <span className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-ink" />
      </span>
    </span>
  );
}
